import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { SurveyLanguage, SurveyLanguageDTO } from "../types/surveyLanguage";
import { SurveyTranslationText, SurveyTranslationTextDTO } from "./surveyTranslationText";
/* eslint-disable import/export */
export abstract class GetAllTranslationsRPC implements
  LeoRPC<GetAllTranslationsRPC.Request, GetAllTranslationsRPC.Response, GetAllTranslationsRPC.Errors.Errors>
{
  abstract execute(
    request: GetAllTranslationsRPC.Request
  ): Promise<LeoRPCResult<GetAllTranslationsRPC.Response, GetAllTranslationsRPC.Errors.Errors>>;
}

export namespace GetAllTranslationsRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  
  export namespace RequestEnums {
    export namespace TranslationType {
      export interface FirstTranslationDTO {
        case: string;
      }
      
      export class FirstTranslation {
        readonly isTranslationTypeFirstTranslation: boolean = true;
      
      
      
      
      
        toDTO(): FirstTranslationDTO {
          const dto: FirstTranslationDTO = {
            case: "FIRST_TRANSLATION",
          };
          return dto;
        }
        }
      
      FirstTranslation.prototype.toString = function toString(): string {
        return `TranslationType.FIRST_TRANSLATION()`;
      };
      
      export interface SpecificTranslationDTO {
        case: string;
        languageId: string;
      }
      
      export class SpecificTranslation {
        readonly isTranslationTypeSpecificTranslation: boolean = true;
      
        readonly languageId: LeoUUID;
      
      
        constructor(
        languageId: LeoUUID
        ) {
          this.languageId = languageId;
        }
      
        static fromDTO(dto: SpecificTranslationDTO): SpecificTranslation {
          const languageId = getLeoUuid(dto, "languageId", InvalidRequestTranslationTypeSpecificTranslationLanguageIdError);
          return new SpecificTranslation(
            languageId
          );
        }
      
        toDTO(): SpecificTranslationDTO {
          const dto: SpecificTranslationDTO = {
            case: "SPECIFIC_TRANSLATION",
              languageId: this.languageId.toDTO()
          };
          return dto;
        }
        }
      
      SpecificTranslation.prototype.toString = function toString(): string {
        return `TranslationType.SPECIFIC_TRANSLATION(languageId='${this.languageId}')`;
      };
      
    
      export type TranslationType = FirstTranslation | SpecificTranslation;
    
      export type TranslationTypeDTO = FirstTranslationDTO | SpecificTranslationDTO;
    
      export const fromDTO = (dto: TranslationTypeDTO): TranslationType => {
        switch (dto.case) {
          case "FIRST_TRANSLATION":
              return new FirstTranslation();
          case "SPECIFIC_TRANSLATION":
              return SpecificTranslation.fromDTO(dto as SpecificTranslationDTO);
          default:
            throw new InvalidRequestTranslationTypeError(
                `Case ${dto.case} is not valid case of TranslationType.`
            );
        }
      };
    }
    
  }
  export interface RequestDTO {
    surveyId: string;
    projectId: string;
    translationType: RequestEnums.TranslationType.TranslationTypeDTO;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetAllTranslationsRPCRequest: boolean = true;
  
    readonly surveyId: LeoUUID;
    readonly projectId: LeoUUID;
    readonly translationType: RequestEnums.TranslationType.TranslationType;
  
  
    constructor(
    surveyId: LeoUUID, 
    projectId: LeoUUID, 
    translationType: RequestEnums.TranslationType.TranslationType
    ) {
      this.surveyId = surveyId;
      this.projectId = projectId;
      this.translationType = translationType;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const surveyId = getLeoUuid(dto, "surveyId", InvalidRequestSurveyIdError);
      const projectId = getLeoUuid(dto, "projectId", InvalidRequestProjectIdError);
      const translationType = RequestEnums.TranslationType.fromDTO(getObject(dto, "translationType", InvalidRequestTranslationTypeError));
      return new Request(
        surveyId,
        projectId,
        translationType
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          surveyId: this.surveyId.toDTO(),
          projectId: this.projectId.toDTO(),
          translationType: this.translationType.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetAllTranslationsRPC(surveyId='${this.surveyId}',projectId='${this.projectId}',translationType='${this.translationType}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  
  export namespace ResponseEnums {
    export namespace TranslationUpdateStatus {
      export interface InProgressDTO {
        case: string;
      }
      
      export class InProgress {
        readonly isTranslationUpdateStatusInProgress: boolean = true;
      
      
      
      
      
        toDTO(): InProgressDTO {
          const dto: InProgressDTO = {
            case: "IN_PROGRESS",
          };
          return dto;
        }
        }
      
      InProgress.prototype.toString = function toString(): string {
        return `TranslationUpdateStatus.IN_PROGRESS()`;
      };
      
      export interface NoTranslationsFoundDTO {
        case: string;
      }
      
      export class NoTranslationsFound {
        readonly isTranslationUpdateStatusNoTranslationsFound: boolean = true;
      
      
      
      
      
        toDTO(): NoTranslationsFoundDTO {
          const dto: NoTranslationsFoundDTO = {
            case: "NO_TRANSLATIONS_FOUND",
          };
          return dto;
        }
        }
      
      NoTranslationsFound.prototype.toString = function toString(): string {
        return `TranslationUpdateStatus.NO_TRANSLATIONS_FOUND()`;
      };
      
      export interface TranslationDataDTO {
        case: string;
        surveyLanguageList: SurveyLanguageDTO[];
        baseLanguage: SurveyLanguageDTO;
        translatedLanguage: SurveyLanguageDTO;
        selectedTranslationTexts: SurveyTranslationTextDTO[];
      }
      
      export class TranslationData {
        readonly isTranslationUpdateStatusTranslationData: boolean = true;
      
        readonly surveyLanguageList: SurveyLanguage[];
        readonly baseLanguage: SurveyLanguage;
        readonly translatedLanguage: SurveyLanguage;
        readonly selectedTranslationTexts: SurveyTranslationText[];
      
        static readonly constraints = {
          "surveyLanguageList": {
            "minSize": 1,
            "maxSize": 8,
          },
          "selectedTranslationTexts": {
            "minSize": 1,
          }
        }
      
        constructor(
        surveyLanguageList: SurveyLanguage[], 
        baseLanguage: SurveyLanguage, 
        translatedLanguage: SurveyLanguage, 
        selectedTranslationTexts: SurveyTranslationText[]
        ) {
          TranslationData.validateSurveyLanguageList(surveyLanguageList);
          this.surveyLanguageList = surveyLanguageList;
          this.baseLanguage = baseLanguage;
          this.translatedLanguage = translatedLanguage;
          TranslationData.validateSelectedTranslationTexts(selectedTranslationTexts);
          this.selectedTranslationTexts = selectedTranslationTexts;
        }
      
        static fromDTO(dto: TranslationDataDTO): TranslationData {
          const surveyLanguageList = getList<SurveyLanguageDTO, SurveyLanguage>(
            dto,
            "surveyLanguageList",
            SurveyLanguage.fromDTO,
            InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListError
          );
          const baseLanguage = SurveyLanguage.fromDTO(getObject(dto, "baseLanguage", InvalidResponseTranslationUpdateStatusTranslationDataBaseLanguageError));
          const translatedLanguage = SurveyLanguage.fromDTO(getObject(dto, "translatedLanguage", InvalidResponseTranslationUpdateStatusTranslationDataTranslatedLanguageError));
          const selectedTranslationTexts = getList<SurveyTranslationTextDTO, SurveyTranslationText>(
            dto,
            "selectedTranslationTexts",
            SurveyTranslationText.fromDTO,
            InvalidResponseTranslationUpdateStatusTranslationDataSelectedTranslationTextsError
          );
          return new TranslationData(
            surveyLanguageList,
            baseLanguage,
            translatedLanguage,
            selectedTranslationTexts
          );
        }
      
        toDTO(): TranslationDataDTO {
          const dto: TranslationDataDTO = {
            case: "TRANSLATION_DATA",
              surveyLanguageList: this.surveyLanguageList.map((e: SurveyLanguage) => { return e.toDTO() }),
              baseLanguage: this.baseLanguage.toDTO(),
              translatedLanguage: this.translatedLanguage.toDTO(),
              selectedTranslationTexts: this.selectedTranslationTexts.map((e: SurveyTranslationText) => { return e.toDTO() })
          };
          return dto;
        }
        private static validateSurveyLanguageList = (surveyLanguageList: SurveyLanguage[]): void => {
          if(surveyLanguageList.length < 1) {
            throw new InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListMinSizeError(
              1,
              `Attribute surveyLanguageList is too short. Size is ${surveyLanguageList.length}. Min size is 1.`
            );
          }
          if(surveyLanguageList.length > 8) {
            throw new InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListMaxSizeError(
              8,
              `Attribute surveyLanguageList is too long. Size is ${surveyLanguageList.length}. Max size is 8.`
            );
          }
        }
        private static validateSelectedTranslationTexts = (selectedTranslationTexts: SurveyTranslationText[]): void => {
          if(selectedTranslationTexts.length < 1) {
            throw new InvalidResponseTranslationUpdateStatusTranslationDataSelectedTranslationTextsMinSizeError(
              1,
              `Attribute selectedTranslationTexts is too short. Size is ${selectedTranslationTexts.length}. Min size is 1.`
            );
          }
        }
        
      }
      
      TranslationData.prototype.toString = function toString(): string {
        return `TranslationUpdateStatus.TRANSLATION_DATA(surveyLanguageList='${this.surveyLanguageList}',baseLanguage='${this.baseLanguage}',translatedLanguage='${this.translatedLanguage}',selectedTranslationTexts='${this.selectedTranslationTexts}')`;
      };
      
    
      export type TranslationUpdateStatus = InProgress | NoTranslationsFound | TranslationData;
    
      export type TranslationUpdateStatusDTO = InProgressDTO | NoTranslationsFoundDTO | TranslationDataDTO;
    
      export const fromDTO = (dto: TranslationUpdateStatusDTO): TranslationUpdateStatus => {
        switch (dto.case) {
          case "IN_PROGRESS":
              return new InProgress();
          case "NO_TRANSLATIONS_FOUND":
              return new NoTranslationsFound();
          case "TRANSLATION_DATA":
              return TranslationData.fromDTO(dto as TranslationDataDTO);
          default:
            throw new InvalidResponseTranslationUpdateStatusError(
                `Case ${dto.case} is not valid case of TranslationUpdateStatus.`
            );
        }
      };
    }
    
  }
  export interface ResponseDTO {
    translationUpdateStatus: ResponseEnums.TranslationUpdateStatus.TranslationUpdateStatusDTO;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetAllTranslationsResponse: boolean = true;
  
    readonly translationUpdateStatus: ResponseEnums.TranslationUpdateStatus.TranslationUpdateStatus;
  
  
    constructor(
    translationUpdateStatus: ResponseEnums.TranslationUpdateStatus.TranslationUpdateStatus
    ) {
      this.translationUpdateStatus = translationUpdateStatus;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const translationUpdateStatus = ResponseEnums.TranslationUpdateStatus.fromDTO(getObject(dto, "translationUpdateStatus", InvalidResponseTranslationUpdateStatusError));
      return new Response(
        translationUpdateStatus
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          translationUpdateStatus: this.translationUpdateStatus.toDTO()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetAllTranslations(translationUpdateStatus='${this.translationUpdateStatus}')`;
  };
  

  export enum RPCError {
    InvalidSurveyId = "INVALID_SURVEY_ID",
    InvalidProjectId = "INVALID_PROJECT_ID",
    InvalidLanguageId = "INVALID_LANGUAGE_ID",
    BaseTranslationNotFound = "BASE_TRANSLATION_NOT_FOUND"
  }

  export namespace Errors {
    
    export interface InvalidSurveyIdDTO {
      code: string;
    }
    
    export class InvalidSurveyId extends LeoRPCError<RPCError> {
      readonly isInvalidSurveyId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidSurveyId;
        super(code);
      }
    
    
      toDTO(): InvalidSurveyIdDTO {
        const dto: InvalidSurveyIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidSurveyId.prototype.toString = function toString(): string {
      return `GetAllTranslationsRPC.INVALID_SURVEY_ID()`;
    };
    
    
    export interface InvalidProjectIdDTO {
      code: string;
    }
    
    export class InvalidProjectId extends LeoRPCError<RPCError> {
      readonly isInvalidProjectId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidProjectId;
        super(code);
      }
    
    
      toDTO(): InvalidProjectIdDTO {
        const dto: InvalidProjectIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidProjectId.prototype.toString = function toString(): string {
      return `GetAllTranslationsRPC.INVALID_PROJECT_ID()`;
    };
    
    
    export interface InvalidLanguageIdDTO {
      code: string;
    }
    
    export class InvalidLanguageId extends LeoRPCError<RPCError> {
      readonly isInvalidLanguageId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidLanguageId;
        super(code);
      }
    
    
      toDTO(): InvalidLanguageIdDTO {
        const dto: InvalidLanguageIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidLanguageId.prototype.toString = function toString(): string {
      return `GetAllTranslationsRPC.INVALID_LANGUAGE_ID()`;
    };
    
    
    export interface BaseTranslationNotFoundDTO {
      code: string;
    }
    
    export class BaseTranslationNotFound extends LeoRPCError<RPCError> {
      readonly isBaseTranslationNotFound: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.BaseTranslationNotFound;
        super(code);
      }
    
    
      toDTO(): BaseTranslationNotFoundDTO {
        const dto: BaseTranslationNotFoundDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    BaseTranslationNotFound.prototype.toString = function toString(): string {
      return `GetAllTranslationsRPC.BASE_TRANSLATION_NOT_FOUND()`;
    };
    

    export type Errors = InvalidSurveyId | InvalidProjectId | InvalidLanguageId | BaseTranslationNotFound;
    export type ErrorsDTO = InvalidSurveyIdDTO | InvalidProjectIdDTO | InvalidLanguageIdDTO | BaseTranslationNotFoundDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidSurveyId:
          return new InvalidSurveyId();
        case RPCError.InvalidProjectId:
          return new InvalidProjectId();
        case RPCError.InvalidLanguageId:
          return new InvalidLanguageId();
        case RPCError.BaseTranslationNotFound:
          return new BaseTranslationNotFound();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestSurveyIdError extends GetAllTranslationsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestSurveyIdError";
  }
}

export class InvalidRequestProjectIdError extends GetAllTranslationsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestProjectIdError";
  }
}

export class InvalidRequestTranslationTypeError extends GetAllTranslationsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestTranslationTypeError";
  }
}

export class InvalidRequestTranslationTypeFirstTranslationError extends InvalidRequestTranslationTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestTranslationTypeFirstTranslationError";
  }
}

export class InvalidRequestTranslationTypeSpecificTranslationError extends InvalidRequestTranslationTypeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestTranslationTypeSpecificTranslationError";
  }
}

export class InvalidRequestTranslationTypeSpecificTranslationLanguageIdError extends InvalidRequestTranslationTypeSpecificTranslationError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestTranslationTypeSpecificTranslationLanguageIdError";
  }
}

export class InvalidResponseTranslationUpdateStatusError extends GetAllTranslationsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusError";
  }
}

export class InvalidResponseTranslationUpdateStatusInProgressError extends InvalidResponseTranslationUpdateStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusInProgressError";
  }
}

export class InvalidResponseTranslationUpdateStatusNoTranslationsFoundError extends InvalidResponseTranslationUpdateStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusNoTranslationsFoundError";
  }
}

export class InvalidResponseTranslationUpdateStatusTranslationDataError extends InvalidResponseTranslationUpdateStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusTranslationDataError";
  }
}

export class InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListError extends InvalidResponseTranslationUpdateStatusTranslationDataError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListError";
  }
}

export class InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListMaxSizeError extends InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListMaxSizeError";
  }
}

export class InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListMinSizeError extends InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusTranslationDataSurveyLanguageListMinSizeError";
  }
}

export class InvalidResponseTranslationUpdateStatusTranslationDataBaseLanguageError extends InvalidResponseTranslationUpdateStatusTranslationDataError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusTranslationDataBaseLanguageError";
  }
}

export class InvalidResponseTranslationUpdateStatusTranslationDataTranslatedLanguageError extends InvalidResponseTranslationUpdateStatusTranslationDataError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusTranslationDataTranslatedLanguageError";
  }
}

export class InvalidResponseTranslationUpdateStatusTranslationDataSelectedTranslationTextsError extends InvalidResponseTranslationUpdateStatusTranslationDataError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusTranslationDataSelectedTranslationTextsError";
  }
}

export class InvalidResponseTranslationUpdateStatusTranslationDataSelectedTranslationTextsMinSizeError extends InvalidResponseTranslationUpdateStatusTranslationDataSelectedTranslationTextsError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseTranslationUpdateStatusTranslationDataSelectedTranslationTextsMinSizeError";
  }
}

export class InvalidResponseInvalidSurveyIdError extends GetAllTranslationsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidSurveyIdError";
  }
}

export class InvalidResponseInvalidProjectIdError extends GetAllTranslationsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidProjectIdError";
  }
}

export class InvalidResponseInvalidLanguageIdError extends GetAllTranslationsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidLanguageIdError";
  }
}

export class InvalidResponseBaseTranslationNotFoundError extends GetAllTranslationsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseBaseTranslationNotFoundError";
  }
}

